import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import React from "react";
import "../commonStyle.css";

/**
 * @function ChangePasswordModal
 * @description for Modal
 * @returns JSX for Modal
 */

const CustomModal = ({
  visible,
  visibleHandler,
  heading,
  body,
  confirmHandler,
  modalSize,
  confirmText = "Confirm",
  footershow = true,
  closeText = "Close"
}) => {
  return (
    <CModal
      aria-labelledby="VerticallyCenteredExample"
      {...(modalSize !== "md" && { size: modalSize })}
      alignment="center"
      scrollable
      visible={visible}
      onClose={visibleHandler}
    >
      <CModalHeader className="py-2">
        <CModalTitle id="VerticallyCenteredExample" className="modal-heading">
          {heading}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>{body()}</CModalBody>
      {footershow && (
        <CModalFooter className="d-flex justify-content-between">
          <CButton color="secondary" onClick={visibleHandler}>
            {closeText}
          </CButton>
          <CButton onClick={confirmHandler} color="primary">
            {confirmText}
          </CButton>
        </CModalFooter>
      )}
    </CModal>
  );
};

export default React.memo(CustomModal);
